export default {
  book: 'Đặt vé',
  book1: 'Chi tiết & Đặt vé',
  seats_left: 'Còn {count} chỗ trống',
  detail: 'Thông tin chi tiết',
  reviews: 'Đánh giá',
  notice: 'Thông báo',
  discount: 'Giảm giá',
  promotion: 'Ưu đãi',
  from: 'Từ',
  important: 'Quan trọng',
}
